import * as Yup from 'yup';

export const closeCashRegisterSchema = Yup.object().shape({
  comment: Yup.string().required(),
  tips: Yup.number().optional().default(0),
});
